import cn from 'clsx'

// Components
import TrackList from 'components/browse/tracklist'

import styles from './trackblock.css'

type TrackBlockProps = {
  value: {
    // (kitti): inline_songs is actually trackIds
    inline_songs: Array<number>
    compact: boolean
    hide_it: boolean
  }
}

const TrackBlock = ({ value: { inline_songs, compact, hide_it } }: TrackBlockProps) => {
  if (hide_it) {
    return null
  }
  const trackIds = inline_songs.map(id => ({ id }))
  return (
    <section className={styles.section}>
      <div className={cn(styles.list, compact && styles.compact, 'trackBlock', compact && 'trackBlockCompact')}>
        {inline_songs.length && (
          <TrackList
            emptyStateMessage="Track not found"
            mode={compact ? 'compact' : undefined}
            trackIds={trackIds}
            request={{ isDone: true, isLoading: false, hasError: false }}
            maxCount={1}
            hideRecommendations
          />
        )}
      </div>
    </section>
  )
}

export default TrackBlock
